<!--公用组件：定时关闭提示框
      /**
      * @desc 组件描述
      * @param {Boolean} [maskVisible] - 是否显示遮罩
      * @param {Number} [timer] - 显示时间
      * @param {String} [content] - 文本内容
      * @example 调用示例
      *this.$toast("提示信息",2000,false)
      */
-->
<template>
    <div class="toast" v-if="visible">
      <div class="toast-container fadeInUp animated">
        <div class="toast-main">
          {{content}}
        </div>
      </div>
      <div class="toast-mask" v-if="maskVisible"></div>
    </div>
</template>

<script>
  export default {
    name: "Toast",
    data() {
      return {
        content: 'hello',
        visible: false,
        timer: 1500,
        maskVisible: false
      };
    }
  };
</script>
<style src="../../static/css/index.css"></style>
<style lang="scss" scoped>
.toast{
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
}

.toast-mask{
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  top: 0;
  position: fixed;
  background-color: #000;
  opacity: 0.7;
}

.toast-container{
  // background-color: #fff;
  position: absolute;
  box-sizing: content-box;
  top: 50%;
  left: 50%;
  z-index: 101;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: 100% 100%;
  @include res-size(
    $padding-top: 15px,
    $padding-bottom: 15px,
    $width: 817px,
    $min-height: 65px,
    $font-size:30px,
  );
  z-index: 101;
}

.toast-main{
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/components/common-components/features/toast/index.vue